import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useMsal } from "@azure/msal-react";

const PageNotFound = () => {
    const { inProgress } = useMsal();

    if (inProgress) return null;

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title="Page not found"
                />
                The page does not exist or you don&apos;t have permissions to see it.
            </Container>
        </div>
    );
};

export default PageNotFound;
